import * as React from "react";
import { Trans, useI18next } from "gatsby-plugin-react-i18next";
import { externalUrlsByLocale } from "../utils/constants";
import { Locales } from "../../locales/languages";
// import HackathonSignup from "./HackathonSignup";

const HackathonDetails = () => {
  const { language } = useI18next();

  return (
    <>
      <section id="details" className="relative">
        <div className="space-custom"></div>
        <div className="container relative z-20">
          <h2 className="heading-2">
            <Trans>Media Partners</Trans>
          </h2>
          <div className="crew-list">
            <div className="crew-item">
              <img
                srcSet="/images/crew/pete2x.webp 2x, /images/crew/pete2x.webp 1x"
                src="/images/crew/pete2x.webp"
                width="246"
                height="246"
                alt="pete"
                className="flex align-center m-auto"
              />
              <p className="text-24 font-semibold">
                <Trans>Pete</Trans>
              </p>
              <p className="leading-none text-menu-white">
                <Trans>@astroboysoup</Trans>
              </p>
            </div>
            <div className="crew-item">
              <img
                src="/images/crew/bullish2x.png"
                width="246"
                height="246"
                alt="bullish"
                className="flex align-center m-auto"
              />
              <p className="text-24 font-semibold">
                <Trans>Bullish Dumpling</Trans>
              </p>
              <p className="leading-none text-menu-white">
                <Trans>@BullishDumpling</Trans>
              </p>
            </div>
            <div className="crew-item">
              <img
                srcSet="/images/crew/rick2x.webp 2x, /images/crew/rick2x.webp 1x"
                src="/images/crew/rick2x.webp"
                width="246"
                height="246"
                alt="rick"
                className="flex align-center m-auto"
              />
              <p className="text-24 font-semibold">
                <Trans>Rick McCracken</Trans>
              </p>
              <p className="leading-none text-menu-white">
                <Trans>@RichardMcCrackn</Trans>
              </p>
            </div>
          </div>
        </div>
        <div className="container h-full absolute top-0 left-0 right-0 bottom-0">
          <div className="layout-grid">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </section>

      <section className="relative">
        <div className="absolute w-full h-auto -z-10 custom-img-position">
          <img
            className="w-full h-full object-cover"
            srcSet="/images/icons/hackathon/star-swirl-top2x.webp 2x, /images/icons/hackathon/star-swirl-top2x.webp 1x"
            src="/images/icons/hackathon/star-swirl-top2x.webp"
            width="1600"
            height="500"
            alt="page-bg"
          />
          <div className="container h-full absolute top-0 left-0 right-0 bottom-0">
            <div className="layout-grid">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>

        <div className="container relative z-20">
          <h2 className="heading-2 mt-64">
            <Trans>Documentation</Trans>
          </h2>
        </div>
        <div className="container relative z-20">
          <ul className="flex flex-wrap lg:flex-nowrap justify-center sm:px-[110px] lg:px-0">
            <a
              className="card-item-3 px-0 mx-10 max-w-[336px] lg:max-w-[336px] w-full"
              href={externalUrlsByLocale.milkomedaDocDeveloperCardano[language as Locales]}
              target="_blank"
              rel="noopener"
            >
              <li>
                <div className="block box-item-1 flex sm:flex flex-row justify-center py-16 bg border border-grey-border">
                  <p>Gitbook for Developers</p>
                  <svg
                    className="opener-icon"
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.83774 5.98554e-06C1.62661 -0.000809335 1.42371 0.0816989 1.27325 0.229544C1.12279 0.377389 1.03696 0.578591 1.03446 0.78932L1.00006 4.81077C0.998817 4.91565 1.0183 5.01976 1.05737 5.11713C1.09644 5.2145 1.15434 5.30323 1.22777 5.37827C1.3012 5.4533 1.38872 5.51317 1.48533 5.55444C1.58194 5.59571 1.68575 5.61758 1.79083 5.6188C1.89656 5.62004 2.0015 5.60035 2.09956 5.56086C2.19762 5.52138 2.28687 5.46288 2.36214 5.38876C2.43742 5.31464 2.49723 5.22636 2.53812 5.12902C2.57901 5.03169 2.60016 4.92723 2.60036 4.82168L2.63005 1.59735H15.3997V14.3792L12.1928 14.4026C11.9814 14.4047 11.7794 14.4902 11.631 14.6404C11.4825 14.7907 11.3997 14.9934 11.4005 15.2045C11.4009 15.3093 11.422 15.4131 11.4626 15.5099C11.5032 15.6066 11.5625 15.6944 11.6371 15.7683C11.7117 15.8422 11.8001 15.9006 11.8973 15.9404C11.9946 15.9802 12.0987 16.0004 12.2038 16L16.203 15.9704C16.4141 15.9695 16.6163 15.8854 16.7656 15.7364C16.9149 15.5874 16.9992 15.3855 17 15.1748V0.79556C16.9992 0.583744 16.914 0.38094 16.7634 0.23175C16.6128 0.0825595 16.4089 -0.000802526 16.1967 5.98554e-06H1.83774ZM3.43804 7.18807C3.33284 7.18766 3.22857 7.20796 3.13124 7.24782C3.0339 7.28768 2.9454 7.3463 2.87079 7.42034C2.79617 7.49437 2.73692 7.58238 2.69642 7.6793C2.65593 7.77623 2.63497 7.88017 2.63477 7.98518C2.63435 8.09059 2.65486 8.19503 2.69508 8.29249C2.7353 8.38996 2.79445 8.47851 2.86912 8.55305C2.9438 8.62758 3.03252 8.68664 3.13016 8.72678C3.2278 8.76693 3.33244 8.78739 3.43804 8.78697H7.08874L1.27044 14.6117C1.12138 14.7613 1.03771 14.9638 1.03771 15.1748C1.03771 15.3858 1.12138 15.5883 1.27044 15.7379C1.34754 15.8154 1.43975 15.8763 1.54136 15.9168C1.64296 15.9573 1.75181 15.9766 1.86118 15.9735C2.06599 15.9674 2.26065 15.8831 2.40503 15.7379L8.24052 9.90231V13.5743C8.24011 13.6792 8.26039 13.7832 8.30022 13.8802C8.34006 13.9773 8.39866 14.0655 8.47267 14.14C8.54668 14.2145 8.63466 14.2736 8.73158 14.3141C8.8285 14.3547 8.93247 14.3757 9.03755 14.3761C9.14315 14.3765 9.2478 14.3561 9.34544 14.3159C9.44309 14.2758 9.53179 14.2167 9.60647 14.1422C9.68114 14.0677 9.7403 13.9791 9.78052 13.8816C9.82075 13.7842 9.84124 13.6797 9.84083 13.5743V7.98518C9.84061 7.88017 9.81965 7.77624 9.77914 7.67932C9.73864 7.5824 9.67939 7.4944 9.60478 7.42036C9.53017 7.34632 9.44168 7.2877 9.34434 7.24784C9.24701 7.20798 9.14275 7.18767 9.03755 7.18807H3.43804Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </li>
            </a>
            <a
              className="card-item-3 px-0 mx-10 max-w-[336px] lg:max-w-[336px] w-full"
              href="https://dcspark.gitbook.io/milkomeda/"
              target="_blank"
              rel="noopener"
            >
              <li>
                <div className="block box-item-1 flex sm:flex flex-row justify-center py-16 bg border border-grey-border">
                  <p>Milkomeda Gitbook</p>
                  <svg
                    className="opener-icon"
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.83774 5.98554e-06C1.62661 -0.000809335 1.42371 0.0816989 1.27325 0.229544C1.12279 0.377389 1.03696 0.578591 1.03446 0.78932L1.00006 4.81077C0.998817 4.91565 1.0183 5.01976 1.05737 5.11713C1.09644 5.2145 1.15434 5.30323 1.22777 5.37827C1.3012 5.4533 1.38872 5.51317 1.48533 5.55444C1.58194 5.59571 1.68575 5.61758 1.79083 5.6188C1.89656 5.62004 2.0015 5.60035 2.09956 5.56086C2.19762 5.52138 2.28687 5.46288 2.36214 5.38876C2.43742 5.31464 2.49723 5.22636 2.53812 5.12902C2.57901 5.03169 2.60016 4.92723 2.60036 4.82168L2.63005 1.59735H15.3997V14.3792L12.1928 14.4026C11.9814 14.4047 11.7794 14.4902 11.631 14.6404C11.4825 14.7907 11.3997 14.9934 11.4005 15.2045C11.4009 15.3093 11.422 15.4131 11.4626 15.5099C11.5032 15.6066 11.5625 15.6944 11.6371 15.7683C11.7117 15.8422 11.8001 15.9006 11.8973 15.9404C11.9946 15.9802 12.0987 16.0004 12.2038 16L16.203 15.9704C16.4141 15.9695 16.6163 15.8854 16.7656 15.7364C16.9149 15.5874 16.9992 15.3855 17 15.1748V0.79556C16.9992 0.583744 16.914 0.38094 16.7634 0.23175C16.6128 0.0825595 16.4089 -0.000802526 16.1967 5.98554e-06H1.83774ZM3.43804 7.18807C3.33284 7.18766 3.22857 7.20796 3.13124 7.24782C3.0339 7.28768 2.9454 7.3463 2.87079 7.42034C2.79617 7.49437 2.73692 7.58238 2.69642 7.6793C2.65593 7.77623 2.63497 7.88017 2.63477 7.98518C2.63435 8.09059 2.65486 8.19503 2.69508 8.29249C2.7353 8.38996 2.79445 8.47851 2.86912 8.55305C2.9438 8.62758 3.03252 8.68664 3.13016 8.72678C3.2278 8.76693 3.33244 8.78739 3.43804 8.78697H7.08874L1.27044 14.6117C1.12138 14.7613 1.03771 14.9638 1.03771 15.1748C1.03771 15.3858 1.12138 15.5883 1.27044 15.7379C1.34754 15.8154 1.43975 15.8763 1.54136 15.9168C1.64296 15.9573 1.75181 15.9766 1.86118 15.9735C2.06599 15.9674 2.26065 15.8831 2.40503 15.7379L8.24052 9.90231V13.5743C8.24011 13.6792 8.26039 13.7832 8.30022 13.8802C8.34006 13.9773 8.39866 14.0655 8.47267 14.14C8.54668 14.2145 8.63466 14.2736 8.73158 14.3141C8.8285 14.3547 8.93247 14.3757 9.03755 14.3761C9.14315 14.3765 9.2478 14.3561 9.34544 14.3159C9.44309 14.2758 9.53179 14.2167 9.60647 14.1422C9.68114 14.0677 9.7403 13.9791 9.78052 13.8816C9.82075 13.7842 9.84124 13.6797 9.84083 13.5743V7.98518C9.84061 7.88017 9.81965 7.77624 9.77914 7.67932C9.73864 7.5824 9.67939 7.4944 9.60478 7.42036C9.53017 7.34632 9.44168 7.2877 9.34434 7.24784C9.24701 7.20798 9.14275 7.18767 9.03755 7.18807H3.43804Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </li>
            </a>
            <a
              className="card-item-3 px-0 mx-10 max-w-[336px] lg:max-w-[336px] w-full"
              href="https://github.com/dcSpark/milkomeda-evm-passive"
              target="_blank"
              rel="noopener"
            >
              <li>
                <div className="block box-item-1 flex sm:flex flex-row justify-center py-16 bg border border-grey-border">
                  <p>Milkomeda evm node configurations</p>
                  <svg
                    className="opener-icon"
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.83774 5.98554e-06C1.62661 -0.000809335 1.42371 0.0816989 1.27325 0.229544C1.12279 0.377389 1.03696 0.578591 1.03446 0.78932L1.00006 4.81077C0.998817 4.91565 1.0183 5.01976 1.05737 5.11713C1.09644 5.2145 1.15434 5.30323 1.22777 5.37827C1.3012 5.4533 1.38872 5.51317 1.48533 5.55444C1.58194 5.59571 1.68575 5.61758 1.79083 5.6188C1.89656 5.62004 2.0015 5.60035 2.09956 5.56086C2.19762 5.52138 2.28687 5.46288 2.36214 5.38876C2.43742 5.31464 2.49723 5.22636 2.53812 5.12902C2.57901 5.03169 2.60016 4.92723 2.60036 4.82168L2.63005 1.59735H15.3997V14.3792L12.1928 14.4026C11.9814 14.4047 11.7794 14.4902 11.631 14.6404C11.4825 14.7907 11.3997 14.9934 11.4005 15.2045C11.4009 15.3093 11.422 15.4131 11.4626 15.5099C11.5032 15.6066 11.5625 15.6944 11.6371 15.7683C11.7117 15.8422 11.8001 15.9006 11.8973 15.9404C11.9946 15.9802 12.0987 16.0004 12.2038 16L16.203 15.9704C16.4141 15.9695 16.6163 15.8854 16.7656 15.7364C16.9149 15.5874 16.9992 15.3855 17 15.1748V0.79556C16.9992 0.583744 16.914 0.38094 16.7634 0.23175C16.6128 0.0825595 16.4089 -0.000802526 16.1967 5.98554e-06H1.83774ZM3.43804 7.18807C3.33284 7.18766 3.22857 7.20796 3.13124 7.24782C3.0339 7.28768 2.9454 7.3463 2.87079 7.42034C2.79617 7.49437 2.73692 7.58238 2.69642 7.6793C2.65593 7.77623 2.63497 7.88017 2.63477 7.98518C2.63435 8.09059 2.65486 8.19503 2.69508 8.29249C2.7353 8.38996 2.79445 8.47851 2.86912 8.55305C2.9438 8.62758 3.03252 8.68664 3.13016 8.72678C3.2278 8.76693 3.33244 8.78739 3.43804 8.78697H7.08874L1.27044 14.6117C1.12138 14.7613 1.03771 14.9638 1.03771 15.1748C1.03771 15.3858 1.12138 15.5883 1.27044 15.7379C1.34754 15.8154 1.43975 15.8763 1.54136 15.9168C1.64296 15.9573 1.75181 15.9766 1.86118 15.9735C2.06599 15.9674 2.26065 15.8831 2.40503 15.7379L8.24052 9.90231V13.5743C8.24011 13.6792 8.26039 13.7832 8.30022 13.8802C8.34006 13.9773 8.39866 14.0655 8.47267 14.14C8.54668 14.2145 8.63466 14.2736 8.73158 14.3141C8.8285 14.3547 8.93247 14.3757 9.03755 14.3761C9.14315 14.3765 9.2478 14.3561 9.34544 14.3159C9.44309 14.2758 9.53179 14.2167 9.60647 14.1422C9.68114 14.0677 9.7403 13.9791 9.78052 13.8816C9.82075 13.7842 9.84124 13.6797 9.84083 13.5743V7.98518C9.84061 7.88017 9.81965 7.77624 9.77914 7.67932C9.73864 7.5824 9.67939 7.4944 9.60478 7.42036C9.53017 7.34632 9.44168 7.2877 9.34434 7.24784C9.24701 7.20798 9.14275 7.18767 9.03755 7.18807H3.43804Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </li>
            </a>
          </ul>
        </div>
        <div className="container h-full absolute top-0 left-0 right-0 bottom-0">
          <div className="layout-grid">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </section>

      {/* Obal After Documentation */}

      <div className="w-full relative">
        <img
          className="w-full relative z-10"
          srcSet="/images/oval_darkblue_BG2x.webp 2x, /images/oval_darkblue_BG2x.webp 1x"
          src="/images/oval_darkblue_BG2x.webp"
          width="1600"
          height="235"
          alt="oval-top"
        />
        <div className="container h-full absolute top-0 left-0 right-0 bottom-0 z-30">
          <div className="layout-grid">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      <section id="details" className="relative agenda-bg">
        <div className="space-custom"></div>
        <div className="container relative z-20">
          <h2 className="heading-2">
            <Trans>Agenda</Trans>
          </h2>
        </div>
        <div className="container">
          <ul className="flex flex-wrap justify-center pb-24">
            <li className="card-item card card-b animation-delay-300 card-anim sm:w-1/2 md:w-1/4">
              <div className="box-item-1 block md:flex">
                <div className="h-full flex items-center flex-col px-16 pt-32 pb-16 text-white justify-start w-full">
                  <p className="text-24 font-semibold">Day 1</p>
                  <p className="mb-8">YouTube stream</p>
                  <div className="block agenda-item bg-see-through-gray h-auto w-full">
                    {/* <p className="text-10 text-orange-light">
                      2:00 - 2:30pm CST
                    </p> */}
                    <p>Welcome!</p>
                  </div>
                  <div className="block agenda-item bg-see-through-gray h-auto w-full">
                    <p>Milkomeda overview</p>
                  </div>
                  <div className="block agenda-item bg-see-through-gray h-auto w-full">
                    <p>Rules &amp; General overview of the Hackathon</p>
                  </div>
                  <div className="block agenda-item bg-see-through-gray h-auto w-full">
                    <p>Short team presentation</p>
                  </div>
                  <div className="block agenda-item bg-see-through-gray h-auto w-full">
                    <p>Kick-off</p>
                  </div>
                </div>
              </div>
            </li>
            <li className="card-item card card-b animation-delay-300 card-anim sm:w-1/2 md:w-1/4">
              <div className="box-item-1 block md:flex">
                <div className="h-full flex items-center flex-col px-16 pt-32 pb-16 text-white justify-start w-full">
                  <p className="text-24 font-semibold">Day 2-5</p>
                  <p className="mb-8">Build</p>
                  <div className="block agenda-item bg-see-through-gray h-auto w-full">
                    <p>Work! Discord Channel open for any doubts!</p>
                  </div>
                </div>
              </div>
            </li>
            <li className="card-item card card-b animation-delay-300 card-anim sm:w-1/2 md:w-1/4">
              <div className="box-item-1 block md:flex">
                <div className="h-full flex items-center flex-col px-16 pt-32 pb-16 text-white justify-start w-full">
                  <p className="text-24 font-semibold">Day 7</p>
                  <p className="mb-8">First feedback</p>
                  <div className="block agenda-item bg-see-through-gray h-auto w-full">
                    <p>Early Feedback</p>
                  </div>
                  <div className="block agenda-item bg-see-through-gray h-auto w-full">
                    <p>How to Pitch Workshop</p>
                  </div>
                </div>
              </div>
            </li>
            <li className="card-item card card-b animation-delay-300 card-anim sm:w-1/2 md:w-1/4">
              <div className="box-item-1 block md:flex">
                <div className="h-full flex items-center flex-col px-16 pt-32 pb-16 text-white justify-start w-full">
                  <p className="text-24 font-semibold">Day 8-end</p>
                  <p className="mb-8">Build</p>
                  <div className="block agenda-item bg-see-through-gray h-auto w-full">
                    <p>Work! Discord Channel open for any doubts!</p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <ul className="flex flex-wrap justify-left md:justify-center">
            <li className="card-item card card-b animation-delay-300 card-anim sm:w-1/2 z-30">
              <div className="box-item-1 block md:flex">
                <div className="h-full flex items-center flex-col px-16 pt-32 pb-16 text-white justify-start w-full">
                  <p className="text-24 font-semibold">Day End</p>
                  <p className="mb-8">
                    Send your video pitch and a link to the project at{" "}
                    <span className="text-orange-light">hackathon@milkomeda.com</span>
                  </p>
                  <div className="block agenda-item bg-see-through-gray h-auto w-full">
                    <p className="pb-4">Pitch + Demo Structure:</p>
                    <div className="day-end text-14 pl-32">
                      <div className="font-semibold relative">
                        <div className="absolute -left-32 top-12">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
                              fill="#F07D00"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M13.8587 7.59127C14.0638 7.79629 14.0638 8.12871 13.8587 8.33373L8.78373 13.4087C8.57871 13.6138 8.24629 13.6138 8.04127 13.4087L5.59127 10.9587C5.38624 10.7537 5.38624 10.4213 5.59127 10.2163C5.79629 10.0112 6.12871 10.0112 6.33373 10.2163L8.4125 12.295L13.1163 7.59127C13.3213 7.38624 13.6537 7.38624 13.8587 7.59127Z"
                              fill="white"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M13.8587 8.33373C14.0638 8.12871 14.0638 7.79629 13.8587 7.59127C13.6537 7.38624 13.3213 7.38624 13.1163 7.59127L8.4125 12.295L6.33373 10.2163C6.12871 10.0112 5.79629 10.0112 5.59127 10.2163C5.38624 10.4213 5.38624 10.7537 5.59127 10.9587L8.04127 13.4087C8.24629 13.6138 8.57871 13.6138 8.78373 13.4087L13.8587 8.33373ZM8.4125 11.6763L6.64309 9.90691C6.26721 9.53103 5.65779 9.53103 5.28191 9.90691C4.90603 10.2828 4.90603 10.8922 5.28191 11.2681L7.73191 13.7181C8.10779 14.094 8.71721 14.094 9.09309 13.7181L14.1681 8.64309C14.544 8.26721 14.544 7.65779 14.1681 7.28191C13.7922 6.90603 13.1828 6.90603 12.8069 7.28191L8.4125 11.6763Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <p>Pitch time: 5 minutes</p>
                      </div>
                      <div className="font-semibold relative">
                        <div className="absolute -left-32 top-12">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
                              fill="#F07D00"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M13.8587 7.59127C14.0638 7.79629 14.0638 8.12871 13.8587 8.33373L8.78373 13.4087C8.57871 13.6138 8.24629 13.6138 8.04127 13.4087L5.59127 10.9587C5.38624 10.7537 5.38624 10.4213 5.59127 10.2163C5.79629 10.0112 6.12871 10.0112 6.33373 10.2163L8.4125 12.295L13.1163 7.59127C13.3213 7.38624 13.6537 7.38624 13.8587 7.59127Z"
                              fill="white"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M13.8587 8.33373C14.0638 8.12871 14.0638 7.79629 13.8587 7.59127C13.6537 7.38624 13.3213 7.38624 13.1163 7.59127L8.4125 12.295L6.33373 10.2163C6.12871 10.0112 5.79629 10.0112 5.59127 10.2163C5.38624 10.4213 5.38624 10.7537 5.59127 10.9587L8.04127 13.4087C8.24629 13.6138 8.57871 13.6138 8.78373 13.4087L13.8587 8.33373ZM8.4125 11.6763L6.64309 9.90691C6.26721 9.53103 5.65779 9.53103 5.28191 9.90691C4.90603 10.2828 4.90603 10.8922 5.28191 11.2681L7.73191 13.7181C8.10779 14.094 8.71721 14.094 9.09309 13.7181L14.1681 8.64309C14.544 8.26721 14.544 7.65779 14.1681 7.28191C13.7922 6.90603 13.1828 6.90603 12.8069 7.28191L8.4125 11.6763Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <p>Presentation &amp; Structure:</p>
                      </div>
                      <ul className="pl-14 list-disc">
                        <li>Create your Deck with slides that explain your project.</li>
                      </ul>
                      <p className="font-semibold">Structure of the Deck:</p>
                      <ul className="pl-14 list-disc">
                        <li>Problem</li>
                        <li>Solution</li>
                        <li>Demo</li>
                        <li>Technology &amp; Design</li>
                        <li>Market &amp; Benchmark</li>
                        <li>Next Steps</li>
                        <li>Team</li>
                      </ul>
                      <div className="font-semibold relative">
                        <div className="absolute -left-32 top-12">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
                              fill="#F07D00"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M13.8587 7.59127C14.0638 7.79629 14.0638 8.12871 13.8587 8.33373L8.78373 13.4087C8.57871 13.6138 8.24629 13.6138 8.04127 13.4087L5.59127 10.9587C5.38624 10.7537 5.38624 10.4213 5.59127 10.2163C5.79629 10.0112 6.12871 10.0112 6.33373 10.2163L8.4125 12.295L13.1163 7.59127C13.3213 7.38624 13.6537 7.38624 13.8587 7.59127Z"
                              fill="white"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M13.8587 8.33373C14.0638 8.12871 14.0638 7.79629 13.8587 7.59127C13.6537 7.38624 13.3213 7.38624 13.1163 7.59127L8.4125 12.295L6.33373 10.2163C6.12871 10.0112 5.79629 10.0112 5.59127 10.2163C5.38624 10.4213 5.38624 10.7537 5.59127 10.9587L8.04127 13.4087C8.24629 13.6138 8.57871 13.6138 8.78373 13.4087L13.8587 8.33373ZM8.4125 11.6763L6.64309 9.90691C6.26721 9.53103 5.65779 9.53103 5.28191 9.90691C4.90603 10.2828 4.90603 10.8922 5.28191 11.2681L7.73191 13.7181C8.10779 14.094 8.71721 14.094 9.09309 13.7181L14.1681 8.64309C14.544 8.26721 14.544 7.65779 14.1681 7.28191C13.7922 6.90603 13.1828 6.90603 12.8069 7.28191L8.4125 11.6763Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <p>+3 days to review for Judges</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="container h-full absolute top-0 left-0 right-0 bottom-0">
          <div className="layout-grid">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </section>

      <div className="space-custom agenda-bg"></div>
      <section className="agenda-bg">
        {/* <HackathonSignup /> */}
        <div className="container relative z-20 custom-disclaimer">
          <div className="block sm:flex text-10 leading-5 font-medium	text-menu-white">
            <div className="pb-24 sm:pb-0 px-12 sm:w-1/2">
              <p className="pb-20">
                The DAO Hackathon is an online competition hosted by Milkomeda Foundation. Projects
                will be evaluated by judges on their technological merits without consideration of
                legal viability. Participants in the Hackathon will create software solely for
                purposes of evaluation by judges as part of a competition and not for commercial
                deployment or release as part of the Hackathon. All participants must comply with
                applicable laws and regulations when releasing any software that they develop as
                part of the Hackathon.
              </p>
              <p>
                The Hackathon ideas and developer resources that Milkomeda Foundation (“MF”)
                provides are for educational and inspirational purposes only. MF does not encourage,
                induce or sanction the deployment of any such applications in violation of
                applicable laws or regulations. MF does not encourage, induce or sanction the
                deployment, integration or use of any such applications (including the code
                comprising any relevant blockchain protocol) in violation of applicable laws or
                regulations and hereby prohibits any such deployment, integration or use. This
                includes use of any such applications by the reader (a) in violation of export
                control or sanctions laws of the United States or any other applicable jurisdiction,
                (b) if the reader is located in or ordinarily resident in a country or territory
                subject to comprehensive sanctions administered by the U.S. Office of Foreign Assets
                Control (OFAC), <span className="font-variant-none">(c)</span> if the reader is or
                is working on behalf of a Specially Designated National (SDN) or a person subject to
                similar blocking or denied party prohibitions, or (d) in violation of the
                Commodities and Exchange Act.
              </p>
            </div>
            <div className="pb-24 sm:pb-0 px-12 sm:w-1/2">
              <p className="pb-20">
                The reader should be aware that U.S. export control and sanctions laws prohibit U.S.
                persons (and other persons that are subject to such laws) from transacting with
                persons in certain countries and territories or that are on the SDN list. As a
                project based primarily on open-source software, it is possible that such sanctioned
                persons may nevertheless bypass prohibitions, obtain the code comprising a
                blockchain protocol (or other project code or applications) and deploy, integrate,
                or otherwise use it. Accordingly, there is a risk to individuals that other persons
                using the blockchain protocol may be sanctioned persons and that transactions with
                such persons would be a violation of U.S. export controls and sanctions law. This
                risk applies to individuals, organizations, and other ecosystem participants that
                deploy, integrate, or use the blockchain protocol code directly (e.g., as a node
                operator), and individuals that transact on the blockchain through light clients,
                third party interfaces, and/or wallet software.
              </p>
              <p>
                MF further represents that any monetary prizes awarded are awarded within the sole
                discretion of MF. Such a monetary prize is not an endorsement of the recipient nor
                the legality of the recipient’s code. All Hackathon participants understand and
                warrant that they are participating on a voluntary basis and that there is no
                expectation of monetary compensation for their participation in the Hackathon.
              </p>
            </div>
          </div>
          <div className="container h-full absolute top-0 left-0 right-0 bottom-0 z-0">
            <div className="layout-grid">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HackathonDetails;
